import { render, staticRenderFns } from "./QuitlyResourceGeneralPane.vue?vue&type=template&id=3c113a18&"
import script from "./QuitlyResourceGeneralPane.vue?vue&type=script&lang=ts&"
export * from "./QuitlyResourceGeneralPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports